module.exports = __webpack_public_path__ + "img/NXN4.e5966785.png";